// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Select, Text, Stack } from '@mantine/core';
import { i18n } from '@lingui/core';
import { useContext } from 'react';
import { IconChevronDown } from '@tabler/icons';
import { ContractContext } from '../../../Service/Context/ContractContextV2';
import { DataS } from '../../../Service/DataS';
import { ContractHead, ContractFooter } from '../../../Types/DocumentT';

const ContractLayoutSection = () => {
  const { contract, savePatch } = useContext(ContractContext);
  const { contractHead, contractFooter } = contract ?? {};

  return (
    <>
      <Text weight="bolder" size="lg" mb="md" mt="md">
        Layout
      </Text>
      <Text mb="md">Hier können Sie die grundsätzliche Vertragsstruktur festlegen</Text>
      <Stack sx={{ maxWidth: 600 }}>
        <Select
          value={contractHead}
          label={i18n._('contract.head')}
          data={DataS.getContractHeadOptions(i18n)}
          onChange={(val: ContractHead) => savePatch({ contractHead: val })}
          styles={{ rightSection: { pointerEvents: 'none' } }}
          rightSection={<IconChevronDown size={14} />}
          rightSectionWidth={25}
        />
        <Select
          value={contractFooter}
          label={i18n._('contract.footer')}
          data={DataS.getContractFooterOptions(i18n)}
          onChange={(val: ContractFooter) => savePatch({ contractFooter: val })}
          styles={{ rightSection: { pointerEvents: 'none' } }}
          rightSection={<IconChevronDown size={14} />}
          rightSectionWidth={25}
        />
      </Stack>
    </>
  );
};

export default ContractLayoutSection;
